<template>
    <dash
        icon="fa fa-truck"
        titulo="ENTREGAS SGF"
        subTitulo="GERENTE"
        @click.native="$router.push({ name: 'Gerentes_Entregas' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
